import { render, staticRenderFns } from "./contentGroup.vue?vue&type=template&id=139d582d&scoped=true&"
import script from "./contentGroup.vue?vue&type=script&lang=js&"
export * from "./contentGroup.vue?vue&type=script&lang=js&"
import style0 from "./contentGroup.vue?vue&type=style&index=0&id=139d582d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139d582d",
  null
  
)

export default component.exports